import Components from "../components";

class FaultMerge extends Components.Base {
  bind() {
    this.on('shown.bs.modal', () => {
      this.$el.find('input[type=text]:first').focus();
    });
  }
}

Components.collection.register({
  selector: '.c-fault-merge-modal',
  klass: FaultMerge,
});
